// Module
var code = "<ul ng-attr-style=\"{{:: node.style }}\"> <li ng-repeat=\"property in properties\" class=nlgAnalysisTreeProperty ng-attr-style={{::style}} nlg-analysis-tree-selected-summary-property node=::node property=::property> </li> </ul>";
// Exports
module.exports = code;